import React from 'react';
import { EmptyState } from '../ui';
import { formatDate } from '../../lib/utils';
import { actionLabel, qtyDisplay, resolveStaff } from './helpers';

interface Props {
  filteredLog: any[];
  fullLog: any[];
  locale: string;
  staffMap: Record<string, string>;
}

export function InventoryHistoryTable({ filteredLog, fullLog, locale, staffMap }: Props) {
  return (
    <div key="history" style={{ animation: 'fadeSlideIn .3s ease-out' }}>
      <div className="tw">
        <table>
          <thead><tr>
            <th>Date</th><th>Item</th><th>Action</th><th>Qty</th><th>Staff / Notes</th>
          </tr></thead>
          <tbody>
            {filteredLog.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: 0 }}>
                <EmptyState
                  icon={
                    <svg viewBox="0 0 32 32" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="16" cy="16" r="12" />
                      <path d="M16 9v7l5 3" />
                    </svg>
                  }
                  title="No transactions found"
                  description={fullLog.length === 0 ? 'Issue or return items to see history here.' : 'Try adjusting the search, action, or date filters.'}
                />
              </td></tr>
            ) : filteredLog.map(entry => {
              const label = actionLabel(entry.action);
              const qty   = qtyDisplay(entry.action, entry.quantity);
              return (
                <tr key={entry.id}>
                  <td className="mono">{formatDate(entry.timestamp, locale)}</td>
                  <td><strong>{entry.item_name}</strong></td>
                  <td>
                    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 4, fontSize: 10, fontWeight: 600, color: label.color, background: label.bg }}>{label.text}</span>
                  </td>
                  <td className="mono" style={{ fontWeight: 600, color: qty.color }}>{qty.symbol}</td>
                  <td style={{ color: 'var(--text2)', fontSize: 12 }}>{resolveStaff(entry, staffMap)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
